export enum COLOR {
  BLUE = "#0046fa", // --primary-50
  ORANGE = "#c36b12", // --accent-tertiary-60
  SUCCESS = "#25a631", // --success-60
  DANGER = "#d33120", // --danger-50;
}
